module.exports = __webpack_public_path__ + "assets/img/solutions.9d256f6c.webp";